import {Type} from '@wix/ambassador-seating-v1-seating-plan/types'
import {PlaceWithTicketInfo} from '@wix/wix-events-commons-statics'
import {getAnyPlaceByPlanPlaceId} from './seating/places'

export const getPlaceInfoForOrderSummary = (seatId: string, places: PlaceWithTicketInfo[]) => {
  const place = getAnyPlaceByPlanPlaceId(places, seatId)

  return {
    sectionTitle: place.section,
    elementTitle: place.elementLabel,
    place,
    area: place.elementType === Type.AREA,
    table: [Type.TABLE, Type.ROUND_TABLE].includes(place.elementType),
  }
}
